// extracted by mini-css-extract-plugin
export default {"Backdrop":"LoadingProvider_Backdrop__6712g","BackdropAnimateIn":"LoadingProvider_BackdropAnimateIn__+AZZa"};